module.exports = function () {
    jQuery(function () {

        if (jQuery('.page-template-page-company #algolia-search-box').length > 0) {

            /* global instantsearch */
            var search = instantsearch({
                appId: algolia.application_id,
                apiKey: algolia.search_api_key,
                indexName: algolia.indices.posts_company.name,
                urlSync: {
                    mapping: {'q': 's'},
                    trackedParameters: ['query']
                }
            });

            instantsearch.widgets.bestResult = function bestResult(container) {
                // See more details in our documentation:
                // https://community.algolia.com/instantsearch.js/documentation/#custom-widgets
                //
                // You can use any JavaScript library you want.
                //
                // This is the custom widget interface (just an object). You need to implement
                // at least render OR init.
                var _search = search;
                return {
                    getConfiguration: function(/*currentSearchParams*/) {
                        // Here we only want one hit in the results, so we configure `hitsPerPage`.
                        //
                        // This parameter is one of Algolia's REST API: https://www.algolia.com/doc/rest#pagination-parameters
                        //
                        // See all the parameters here: https://www.algolia.com/doc/rest
                        //
                        // In the end, the underlying JS object being configured is the JavaScript helper of Algolia.
                        // See https://community.algolia.com/algoliasearch-helper-js/docs/SearchParameters.html
                        return {
                            // hitsPerPage: 1
                        };
                    },
                    init: function(params) {
                        // params.state
                        // params.helper
                        //
                        // Nothing to do here, only present for documentation
                    },
                    render: function(params) {
                        // params.results
                        // params.state
                        // params.helper

                        var results = params.results;
                        if (results.hits.length === 0) {
                            container.innerHTML = 'No results';
                        } else {
                            container.innerHTML =
                                '<select onchange="_search.templatesConfig.helpers.setQuery(this.value).search();"><option>Select one</option><option>' + results.hits[0].post_title + '</option></select>';
                            /*container.innerHTML =
                                'Name: ' + results.hits[0].name + '<br/>' +
                                'Price: ' + results.hits[0].price + '<br/>' +
                                'Image: <img src="' + results.hits[0].image + '" />';*/
                        }
                    }
                };
            };

            search.addWidget(
                instantsearch.widgets.searchBox({
                    container: '.page-template-page-company #algolia-search-box',
                    placeholder: 'Search...',
                    wrapInput: false
                })
            );

            search.addWidget(
                instantsearch.widgets.stats({
                    container: '.page-template-page-company #algolia-stats'
                })
            );

            var hitTemplate = jQuery("#tmpl-hit").html();

            var noResultsTemplate = 'No results for the search query: "<strong>{{query}}</strong>".';

            search.addWidget(
                instantsearch.widgets.hits({
                    container: '.page-template-page-company #algolia-hits',
                    hitsPerPage: 6,
                    templates: {
                        empty: noResultsTemplate,
                        item: hitTemplate
                    }
                })
            );

            search.addWidget(
                instantsearch.widgets.bestResult(
                    document.querySelector('#best-result')
                )
            );

            search.addWidget(
                instantsearch.widgets.hitsPerPageSelector({
                    container: '.page-template-page-company #hits-per-page-selector',
                    options: [
                        {value: 2, label: '2 per page'},
                        {value: 6, label: '6 per page'},
                        {value: 12, label: '12 per page'},
                        {value: 24, label: '24 per page'}
                    ]
                })
            );

            search.addWidget(
                instantsearch.widgets.pagination({
                    container: '.page-template-page-company #algolia-pagination'
                })
            );


            search.addWidget(
                instantsearch.widgets.refinementList({
                    container: '.page-template-page-company #date',
                    attributeName: 'post_type_label',
                    operator: 'or',
                    limit: 10,
                    templates: {
                        header: '<h3 class="widgettitle">Types</h3>'
                    }
                })
            );

            search.addWidget(
                instantsearch.widgets.menu({
                    container: '.page-template-page-company #facet-genre',
                    attributeName: 'genre.name',
                    sortBy: ['isRefined', 'count:desc', 'name:asc'],
                    limit: 10,
                    templates: {
                        header: '<h3 class="widgettitle">Genre</h3>'
                    }
                })
            );


            search.addWidget(
                instantsearch.widgets.menu({
                    container: '.page-template-page-company #facet-categories',
                    attributeName: 'taxonomy_category',
                    sortBy: ['isRefined', 'count:desc', 'name:asc'],
                    limit: 10,
                    templates: {
                        header: '<h3 class="widgettitle">Categories</h3>'
                    }
                })
            );

            search.addWidget(
                instantsearch.widgets.refinementList({
                    container: '.page-template-page-company #facet-tags',
                    attributeName: 'taxonomy_post_tag',
                    operator: 'and',
                    limit: 15,
                    sortBy: ['isRefined', 'count:desc', 'name:asc'],
                    templates: {
                        header: '<h3 class="widgettitle">Tags</h3>'
                    }
                })
            );

            search.addWidget(
                instantsearch.widgets.menu({
                    container: '.page-template-page-company #facet-users',
                    attributeName: 'post_author.display_name',
                    sortBy: ['isRefined', 'count:desc', 'name:asc'],
                    limit: 10,
                    templates: {
                        header: '<h3 class="widgettitle">Authors</h3>'
                    }
                })
            );

            search.templatesConfig.helpers.relevantContent = function () {
                var attributes = ['content', 'title6', 'title5', 'title4', 'title3', 'title2', 'title1'];
                var attribute_name;
                for (var index in attributes) {
                    attribute_name = attributes[index];
                    if (this._highlightResult[attribute_name].matchedWords.length > 0) {
                        return this._snippetResult[attribute_name].value;
                    }
                }

                return this._snippetResult[attributes[0]].value;
            };

            search.start();

            jQuery('.page-template-page-company #algolia-search-box input').attr('type', 'search');
        }
    });
};